import { render, staticRenderFns } from "./PowerDataBase.vue?vue&type=template&id=03620b5d&scoped=true&"
import script from "./PowerDataBase.vue?vue&type=script&lang=js&"
export * from "./PowerDataBase.vue?vue&type=script&lang=js&"
import style0 from "./PowerDataBase.vue?vue&type=style&index=0&id=03620b5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03620b5d",
  null
  
)

export default component.exports